var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{attrs:{"id":"fade-layer"},on:{"click":function($event){return _vm.$emit('turn-on')}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }